import * as Routes from 'constants/Routes'
import { injectReducer } from 'common/reducers'

export default store => ({
  path: Routes.HOME,
  getComponent: async function (nextState, cb) {
    const [module, reducer] = await Promise.all([
      import('./containers/HomeContainer'),
      import('./reducers')
    ])

    injectReducer(store, { key: 'home', reducer: reducer.default })

    cb(null, module.default)
  }
})
